enum FilterEvents {
  cashDown = 'Updated Cash Down Filter',
  monthlyPayment = 'Updated Monthly Payment Filter',
  price = 'Updated Price Filter'
}

export default FilterEvents;
